import React from "react";
import ReactDOM from "react-dom";
import "babel-polyfill";

import App from "./ui/App";

const container = document.getElementById("app");
ReactDOM.render(<App />, container);
